import styled from 'styled-components';
import { Icon, Heading, Paragraph } from 'components';

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MultiIconWrapper = styled.div`
  position: relative;
`;

export const SuperscriptIcon = styled(Icon)`
  position: absolute;
  top: -10%;
  right: -10%;
  background-color: white;
  border-radius: 20px;
`;

export const RequireSupportingFilesTitle = styled(Heading)`
  text-align: center;
  margin: ${props => props.theme.spacing.default};
`;

export const CenteredParagraph = styled(Paragraph)`
  text-align: center;
`;

export const RequireSupportingFilesIconWrapper = styled.div`
  margin: 0 auto;
`;

export const FooterText = styled(Heading)`
  text-align: center;
`;
